import React, { Component } from 'react';

class EnviromaDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {
        return (
            <div className="animated fadeIn">

            </div>
        );
    }
}

export default EnviromaDevices;